const getUnitId = state => state.unitId;
const getFloorplan = state => state.floorplan;

export default {
    getUnitId,
    getFloorplan,
};
